import { svg } from "./svgStyles";

export const buttonBase = {
  alignItems: "center",
  border: "solid 1px",
  borderRadius: "2px",
  boxSizing: "border-box",
  cursor: "pointer",
  display: "inline-flex",
  flexDirection: "row",
  fontFamily: "body",
  fontWeight: "light",
  justifyContent: "center",
  lineHeight: "1",
  textTransform: "uppercase",
  textDecoration: "none",
  whiteSpace: "nowrap",
  transition: "background-color 0.3s, color 0.3s, border-color 0.3s",
};

export const buttonDisabledDark = {
  "&[disabled], &:disabled": {
    background: "grey7",
    borderColor: "grey7",
    color: "grey9",
    cursor: "not-allowed",
    ...svg("grey9"),
  },
};

export const buttonDisabledLight = {
  "&[disabled], &:disabled": {
    background: "grey9",
    borderColor: "grey9",
    color: "grey7",
    cursor: "not-allowed",
    ...svg("grey7"),
  },
};

export const buttonPrimaryDark = {
  ...buttonBase,
  background: "black",
  borderColor: "black",
  color: "white",
  ...svg("white"),

  "&:hover, &:focus": {
    background: "primary",
    borderColor: "primary",
    color: "white",
  },

  ...buttonDisabledDark,
};

export const buttonPrimaryLight = {
  ...buttonBase,
  background: "white",
  borderColor: "white",
  color: "black",
  ...svg("black"),

  "&:hover, &:focus": {
    color: "primary",
    ...svg("primary"),
  },

  ...buttonDisabledLight,
};

export const buttonSecondaryDarkSelected = {
  background: "primary",
  color: "white",
  borderColor: "primary",
  ...svg("white"),

  "&:hover, &:focus": {
    background: "primary",
    borderColor: "primary",
    color: "white",
    ...svg("white"),
  },
};

export const buttonSecondaryDark = {
  ...buttonBase,
  background: "transparent",
  borderColor: "grey5",
  color: "black",
  ...svg("black"),

  "&:hover, &:focus": {
    background: "transparent",
    borderColor: "primary",
    color: "primary",
    ...svg("primary"),
  },

  "&[disabled], &:disabled": {
    background: "grey9",
    borderColor: "grey5",
    color: "grey5",
    cursor: "not-allowed",
    ...svg("grey5"),

    "& svg": {
      background: "grey8",
    },
  },
};

export const buttonSecondaryLight = {
  ...buttonBase,
  background: "transparent",
  borderColor: "white",
  color: "white",
  ...svg("white"),

  "&:hover, &:focus": {
    background: "transparent",
    borderColor: "primary",
    color: "primary",
    ...svg("primary"),
  },

  "&[disabled], &:disabled": {
    borderColor: "grey9",
    color: "grey9",
    cursor: "not-allowed",
    ...svg("grey9"),
  },
};

export const buttonIcon = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const buttonSmall = {
  fontSize: "16px",
  letterSpacing: "0.1em",
  padding: "0 21px",
  height: "30px",

  ".button__inner": {
    padding: "6px 0",
  },

  ".button__icon-before": {
    ...buttonIcon,
    marginLeft: "-5px",
    marginRight: "12px",
    maxHeight: "16px",
  },

  ".button__icon-after": {
    ...buttonIcon,
    marginRight: "-5px",
    marginLeft: "12px",
    maxHeight: "16px",
  },
};

export const buttonMedium = {
  fontSize: "20px",
  letterSpacing: "0.05em",
  padding: "0 30px",
  height: "40px",

  ".button__inner": {
    padding: "9px 0",
  },

  ".button__icon-before": {
    ...buttonIcon,
    marginLeft: "-5px",
    marginRight: "20px",
    maxHeight: "30px",
  },

  ".button__icon-after": {
    ...buttonIcon,
    marginRight: "-5px",
    marginLeft: "20px",
    maxHeight: "30px",
  },
};

export const buttonLarge = {
  fontSize: "30px",
  letterSpacing: "0.025em",
  padding: "0 45px",
  height: "60px",

  ".button__inner": {
    padding: "14px 0",
  },

  ".button__icon-before": {
    ...buttonIcon,
    marginLeft: "-15px",
    marginRight: "30px",
    maxHeight: "50px",
  },

  ".button__icon-after": {
    ...buttonIcon,
    marginRight: "-15px",
    marginLeft: "30px",
    maxHeight: "50px",
  },
};

export const buttonRound = {
  borderRadius: "1000px",
};

export const buttonIconOnly = {
  paddingLeft: 0,
  paddingRight: 0,

  ".button__icon-before, .button__icon-after": {
    marginLeft: "unset",
    marginRight: "unset",
  },
};

export const buttonIconOnlySmall = {
  ...buttonIconOnly,
  minWidth: "30px",
};

export const buttonIconOnlyMedium = {
  ...buttonIconOnly,
  minWidth: "40px",
};

export const buttonIconOnlyLarge = {
  ...buttonIconOnly,
  minWidth: "60px",
};
